export default "__VITE_ASSET__CZ4oi6Ns__"